import React, { useEffect, useState } from "react";
import { SpinnerImg } from "../../loader/Loader";
import "./RequestsList.scss";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { AiOutlineEye } from "react-icons/ai";
import Search from "../../search/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  FILTER_REQUESTS,
  selectFilteredRequests,
} from "../../../redux/features/request/requestFilterSlice";
import ReactPaginate from "react-paginate";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  deleteRequest,
  getRequests,
} from "../../../redux/features/request/requestSlice";
import { Link } from "react-router-dom";

const RequestList = ({ requests, isLoading }) => {
  const [search, setSearch] = useState("");
  const filteredRequests = useSelector(selectFilteredRequests);

  const dispatch = useDispatch();

  const shortenText = (text, n) => {
    if (text.length > n) {
      const shortenedText = text.substring(0, n).concat("...");
      return shortenedText;
    }
    return text;
  };

  const delRequest = async (id) => {
    console.log(id);
    await dispatch(deleteRequest(id));
    await dispatch(getRequests());
  };

  const confirmDelete = (id) => {
    confirmAlert({
      title: "Delete request",
      message: "Are you sure you want to delete this request.",
      buttons: [
        {
          label: "Delete",
          onClick: () => delRequest(id),
        },
        {
          label: "Cancel",
          // onClick: () => alert('Click No')
        },
      ],
    });
  };

  //   Begin Pagination
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;

    setCurrentItems(filteredRequests.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(filteredRequests.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, filteredRequests]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredRequests.length;
    setItemOffset(newOffset);
  };
  //   End Pagination

  useEffect(() => {
    dispatch(FILTER_REQUESTS({ requests, search }));
  }, [requests, search, dispatch]);

  return (
    <div className="request-list">
      <hr />
      <div className="table">
        <div className="--flex-between --flex-dir-column">
          <span>
            <h3>Medicine Requests</h3>
          </span>
          <span>
            <Search
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </span>
        </div>

        {isLoading && <SpinnerImg />}

        <div className="table">
          {!isLoading && requests.length === 0 ? (
            <p>-- No request found, please add a request...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>s/n</th>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.map((request, index) => {
                  const { _id, name, quantity } = request;
                  return (
                    <tr key={_id}>
                      <td>{index + 1}</td>
                      <td>{shortenText(name, 16)}</td>
                      <td>{quantity}</td>
                      <td className="icons">
                        <span>
                          <Link to={`/request-detail/${_id}`}>
                            <AiOutlineEye size={25} color={"purple"} />
                          </Link>
                        </span>
                        <span>
                          <Link to={`/edit-request/${_id}`}>
                            <FaEdit size={20} color={"green"} />
                          </Link>
                        </span>
                        <span>
                          <FaTrashAlt
                            size={20}
                            color={"red"}
                            onClick={() => confirmDelete(_id)}
                          />
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="Prev"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          pageLinkClassName="page-num"
          previousLinkClassName="page-num"
          nextLinkClassName="page-num"
          activeLinkClassName="activePage"
        />
      </div>
    </div>
  );
};

export default RequestList;
